// extracted by mini-css-extract-plugin
export default {"BLLoader_backdrop":"BLLoader_BLLoader_backdrop__ffkEm","BLLoader_content":"BLLoader_BLLoader_content__pztx3"};